export default __webpack_public_path__ + "static/media/next.8dcbb7a1.svg";